module.exports = __webpack_public_path__ + "static/media/logo.8022cee7.svg";